import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button } from "@mui/material";
import ViewInArIcon from "@mui/icons-material/ViewInAr";

/** Floating button that respawns the visitor in the 3D world, right where they left it. */
const BackToWorldButton: React.FC = () => (
  <Button
    component={RouterLink}
    to="/"
    variant="contained"
    startIcon={<ViewInArIcon />}
    sx={{
      position: "fixed",
      bottom: 20,
      right: 20,
      zIndex: 1200,
      backgroundColor: "primary.main",
      boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
      "&:hover": { backgroundColor: "primary.dark" },
    }}
  >
    Back to 3D World
  </Button>
);

export default BackToWorldButton;
